import { forwardRef, type Ref, type SVGProps } from "react";

function SvgRequestSent(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <rect
        width={90}
        height={60}
        x={43}
        y={30}
        stroke="url(#request_sent_svg__a)"
        strokeWidth={10}
        rx={16}
      />
      <path
        stroke="#0D2B57"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m52 39 37.029 25L124 39"
      />
      <path stroke="#0C1C43" strokeLinecap="round" d="M27 53H7m20 7H13m14 6h-8" />
      <defs>
        <linearGradient
          id="request_sent_svg__a"
          x1={88}
          x2={88}
          y1={30}
          y2={90}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRequestSent);
export default ForwardRef;
